<template>
  <div class="contact">
    <!--右边侧边栏-->
    <div class="ask_o">
      <div class="pc ask">
        <div class="item customer_service" @click="handleCustomerServiceClick()">
          <img class="ask_o_icon" src="../../../../assets/images/icon-headphone-white.svg" alt="在线客服" />
          <p class="ask_o_discription">在线客服</p>
        </div>
        <div class="item ask_o_phone_call">
          <div class="ask_o_phone_call_right">
            <a href="tel:0571-85785223" @click="phoneCallTrack()" class="ask_o_phone_number_box">
              <p class="ask_o_discription">销售热线</p>
              <p class="ask_o_phone_number" style="font-weight:600;">0571-85785223</p>
            </a>
            <a href="tel:4000878198" @click="phoneCallTrack()" class="ask_o_phone_number_box second">
              <p class="ask_o_discription">售后服务</p>
              <p class="ask_o_phone_number" style="font-weight:600;">400-0878-198</p>
            </a>
          </div>
          <div class="ask_o_phone_call_left">
            <div class="ask_o_icon"></div>
            <p class="ask_o_discription">电话咨询</p>
          </div>
        </div>
        <!--微信咨询-->
        <div class="item ask_o_weixin_call">
          <div class="ask_o_weixin_call_right">
            <img :src="require('@/assets/images/code.png')" />
            <div class="text">
              <h6>关注专属顾问</h6>
              <h6>获取1份数字化报告</h6>
            </div>
          </div>
          <div class="ask_o_weixin_call_left">
            <div class="ask_o_icon"></div>
            <p class="ask_o_discription">微信咨询</p>
          </div>
        </div>
        <!--申请试用-->
        <div class="item ask_o_apply_use">
          <a href="javascript:;" @click="showDialog">
            <div class="ask_o_icon"></div>
            <p class="ask_o_discription">申请试用</p>
          </a>
        </div>
        <div v-show="topShow" class="item ask_o_back_top" @click="toTop()">
          <img class="ask_o_icon" src="https://asset.esign.cn/apps/esign/images/totop-icon.svg" alt="" />
        </div>
      </div>
      <div class="m">
        <a href="javascript:;" @click="handleCustomerServiceClick" class="md__sign_officewebsite_onlineservice">
          <img :src="require('@/assets/images/erji.png')" alt="" />在线客服
        </a>
        <a @click="mbCallClick" href="javascript:;" class="md__sign_officewebsite_phonecallconsult">
          <img :src="require('@/assets/images/phone.png')" alt="" />电话咨询
        </a>
      </div>
      <div :class="['md__sign_officewebsite_phonecallconsult_dialog', phoneActive ? 'phoneActive' : '']">
        <div class="md__sign_officewebsite_phonecallconsult_mask" @click="mdMaskClick()"></div>
        <div class="md__sign_officewebsite_phonecallconsult_content">
          <a href="tel:0571-85785223" @click="phoneCallTrack()" class="mb_mask_o_phone_number_box first">
            <p class="mb_mask_o_discription">销售热线：</p>
            <p class="mb_mask_o_phone_number">0571-85785223</p>
          </a>
          <a href="tel:4000878198" @click="phoneCallTrack()" class="mb_mask_o_phone_number_box second">
            <p class="mb_mask_o_discription">售后服务：</p>
            <p class="mb_mask_o_phone_number">400-0878-198</p>
          </a>
        </div>
      </div>
    </div>
    <!-- <div class="contact__btn contact__btn-customer" @click="handleCustomerServiceClick">
      <div>
        <img :src="require('@/assets/images/icon-headphone-white.svg')" />
      </div>
      <div>在线客服</div>
    </div>

    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:0571-85785223" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>电话咨询</div>
      </a>
      <div class="phone-number">0571-85785223</div>
    </div>
    <div class="contact__btn-phone">
      <a class="contact__btn" href="tel:400-0878-198" @click="handlePhoneClick">
        <div>
          <img :src="require('@/assets/images/icon-phone-white.svg')" />
        </div>
        <div>申请试用</div>
      </a>
      <div class="phone-number">400-0878-198</div>
    </div> -->
  </div>
</template>

<script>
import qiyuMixin from '../mixins/qiyu.js'

export default {
  mixins: [qiyuMixin],
  components: {
    // BackToTop: () => import('./BackToTop.vue'),
  },
  mounted() {
    this.pc_ask_o_srollTo()
    this.addQiyuScript()
  },
  data() {
    return {
      timerss: '',
      phoneActive: false,
      topShow:false,
    }
  },
  props: {
    landingPageName: {
      type: String,
      default: '',
    },
  },
  methods: {
    showDialog() {
      this.$emit('showDialog')
    },
    // handleBackToTopClick() {
    //   window.scrollTo({
    //     top: 0,
    //     behavior: 'smooth',
    //   })
    // },
    // handlePhoneClick() {
    //   // TODO:
    //   if (this.landingPageName === 'esignPropagate') {
    //     window.meteor && window.meteor.track && window.meteor.track('phone', { convert_id: '1655142884209676' })
    //   }
    //   this.$tsignData.track('sign_olandingpage_phonecallconsult')
    //   this.$tsignData.track('click_phone_call')
    // },

    // mdMaskClick() {
    //   $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'none')
    //   document.documentElement.style.overflow = 'auto'
    // },

    // mbCallClick() {
    //   $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'block')
    //   document.documentElement.style.overflow = 'hidden'
    // },
    toTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
      // window.tsignData && window.tsignData.track('click_back_top')
      // //右侧滚回顶部
      // timerss = setInterval(function () {
      //   var globalSt = document.documentElement.scrollTop || document.body.scrollTop;

      //   if (timerss) {
      //     if (globalSt <= 0) {
      //       clearInterval(timerss);
      //       document.documentElement.scrollTop = 0;
      //       document.body.scrollTop = 0;
      //     } else {
      //       globalSt -= 80;
      //       document.documentElement.scrollTop = globalSt;
      //       document.body.scrollTop = globalSt;
      //     }
      //   }
      // }, 10);
    },

    pc_ask_o_srollTo() {
      let globalSt = document.documentElement.scrollTop || document.body.scrollTop
      let screenHeight = window.screen.height
      console.log('globalSt', 'screenHeight', globalSt, screenHeight)
      if (globalSt > screenHeight) {
        this.topShow = true
      } else {
        this.topShow = false
      }
    },
    // window.addEventListener('scroll', pc_ask_o_srollTo)

    mdMaskClick() {
      this.phoneActive = false
      // $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'none')
      // document.documentElement.style.overflow = 'auto'
    },

    mbCallClick() {
      this.phoneActive = true
      // $('.md__sign_officewebsite_phonecallconsult_dialog').css('display', 'block')
      // document.documentElement.style.overflow = 'hidden'
    },
  },
}
</script>

<style lang="less" scoped>
.ask_o .ask {
  width: 2.24rem;
  height: 7.4667rem;
  position: fixed;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  z-index: 10000;
}
.ask_o .ask .item {
  cursor: pointer;
}
.ask_o .ask .customer_service {
  position: absolute;
  top:0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .customer_service:hover {
 width:1.8133rem;
}
.ask_o .ask .ask_o_phone_call {
  position: absolute;
  top:1.7333rem;
  right: 0;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left{
  position: absolute;
  top:0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover {
 width:1.8133rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_icon {
  background: url('../../../../assets/images/grayPhone.png') no-repeat top left;
  background-size: .5333rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover .ask_o_icon {
  background: url('../../../../assets/images/redPhone.png') no-repeat top left;
  background-size: .5333rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left:hover .ask_o_discription {
 color: #e61717;
}
.ask_o .ask .ask_o_phone_call:hover .ask_o_phone_call_right {
  opacity: 1;
  visibility: visible;
}
.ask_o .ask .ask_o_weixin_call {
  position: absolute;
  top:3.4667rem;
  right: 0;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left {
  position: absolute;
  top:0;
  right: 0;
  transition: all 0.5s ease;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover {
 width:1.8133rem;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_icon {
  background: url('../../../../assets/images/black-WX.png') no-repeat top left;
  background-size: .5333rem;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover .ask_o_icon {
  background: url('../../../../assets/images/red-WX.png') no-repeat top left;
  background-size: .5333rem;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left:hover .ask_o_discription {
 color: #e61717;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_right {
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  width: 3.8667rem;
  padding: .32rem;
  background: #ffffff;
  box-shadow: 0px .0533rem .4rem 0px rgba(0, 0, 0, 0.1);
  border-radius: .0533rem;
  border: 1px solid #dcdee2;
  position: absolute;
  top: 0px;
  right: 2.1333rem;
}
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_right .text {
  margin-top: .2667rem;
  text-align: center;
  color: #666666;
}
.ask_o .ask .ask_o_weixin_call:hover .ask_o_weixin_call_right {
  opacity: 1;
  visibility: visible;
}

.ask_o .ask .ask_o_apply_use {
position: absolute;
top:5.2rem;
right: 0;
transition: all 0.5s ease;
}
.ask_o .ask .ask_o_apply_use a {
margin-top: .2133rem;
display: flex;
flex-direction: column;
align-items: center;
width:100%;
height: 100%;
}
.ask_o .ask .ask_o_apply_use:hover {
 width:1.8133rem;
}
.ask_o .ask .ask_o_apply_use .ask_o_icon {
  background: url('../../../../assets/images/grayNotebook.png') no-repeat top left;
  background-size: .5333rem;
}
.ask_o .ask .ask_o_apply_use:hover .ask_o_icon {
 background: url('../../../../assets/images/redNotebook.png') no-repeat top left;
 background-size: .5333rem;
}
.ask_o .ask .ask_o_apply_use:hover .ask_o_discription {
 color: #e61717;
}
.ask_o .ask .customer_service {
  background: #e61717;
}
.ask_o .ask .customer_service:hover {
  background: #e63717;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left,
.ask_o .ask .ask_o_apply_use{
  width: 100%;
  height: 100%;
  background: #ffffff;
}
.ask_o .ask .customer_service,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left,
.ask_o .ask .ask_o_apply_use{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.ask_o .ask .customer_service,
.ask_o .ask .ask_o_phone_call,
.ask_o .ask .ask_o_weixin_call,
.ask_o .ask .ask_o_apply_use{
  box-shadow: 0px .0533rem .4rem 0px rgba(0, 0, 0, 0.1);
  width: 1.6rem;
  height: 1.4933rem;
  border-radius: .0533rem;
}
.ask_o .ask .customer_service .ask_o_icon,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_icon,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_icon,
.ask_o .ask .ask_o_apply_use .ask_o_icon{
  width: .5333rem;
  height: .5333rem;
}
.ask_o .ask .customer_service .ask_o_discription {
  color: #ffffff;
}

.ask_o .ask .customer_service .ask_o_discription,
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_left .ask_o_discription,
.ask_o .ask .ask_o_weixin_call .ask_o_weixin_call_left .ask_o_discription,
.ask_o .ask .ask_o_apply_use .ask_o_discription{
  margin-top: .0533rem;
  word-break: break-all;
  font-size: .32rem;
  font-weight: 400;
  line-height: .48rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right {
  transition: all 0.4s ease-in-out;
  opacity: 0;
  visibility: hidden;
  box-sizing: border-box;
  width: 3.8667rem;
  padding: .32rem;
  background: #ffffff;
  box-shadow: 0px .0533rem .4rem 0px rgba(0, 0, 0, 0.1);
  border-radius: .0533rem;
  border: 1px solid #dcdee2;
  position: absolute;
  top: 1px;
  right: 2.1333rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_phone_number_box {
  display: inline-block;
}
.ask_o
  .ask
  .ask_o_phone_call
  .ask_o_phone_call_right
  .ask_o_phone_number_box.second {
  margin-top: .16rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_discription {
  height: .4533rem;
  font-size: .32rem;
  font-weight: 400;
  color: #666666;
  line-height: .4533rem;
}
.ask_o .ask .ask_o_phone_call .ask_o_phone_call_right .ask_o_phone_number {
  height: .5867rem;
  color: #e61717;
  font-size: .3733rem;
  font-weight: 400;
  line-height: .5867rem;
}
.ask_o .ask .ask_o_back_top {
  width: 1.1733rem;
  height: 1.1733rem;
  opacity: 0;
  visibility: hidden;
  transition: all 0.4s ease-in-out;
  border-radius: .5867rem;
  background: #ffffff;
  position: fixed;
  right: .5333rem;
  bottom: .5333rem;
  box-shadow: 0px .0533rem .4rem 0px rgba(0, 0, 0, 0.1);
}
.ask_o .ask .ask_o_back_top .ask_o_icon {
  width: .3733rem;
  height: .3733rem;
  margin-left: .4rem;
  margin-top: .4rem;
}
.ask_o .m {
  display: none;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 99999;
}
.ask_o .m a {
  width: 50%;
  height: 1.3333rem;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .32rem;
  color: #fff;
  background: #000;
}
.ask_o .m a:nth-child(2) {
  background: #e61717;
}
.ask_o .m a:nth-child(2) img {
  width: .7467rem;
}
.ask_o .m a img {
  width: .64rem;
  margin-right: .2667rem;
}
.md__sign_officewebsite_phonecallconsult_dialog {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 9999999999999999;
  display: none;
  overflow: hidden;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_mask {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.49);
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content {
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 6.9333rem;
  height: 3.2rem;
  background: #ffffff;
  border-radius: .1067rem;
  padding: 0 .3733rem;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box {
  height: 1.6rem;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box.first {
  border: 0px solid #f2f2f2;
  border-bottom-width: 1px;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box
  .mb_mask_o_phone_number {
  font-size: .4267rem;
  font-weight: 400;
  color: #e61717;
}
.md__sign_officewebsite_phonecallconsult_dialog
  .md__sign_officewebsite_phonecallconsult_content
  .mb_mask_o_phone_number_box
  .mb_mask_o_discription {
  font-size: .4267rem;
  font-weight: 400;
  color: #333333;
}

.ask_o .pc {
  display: none;
}
.ask_o .m {
  display: flex;
  align-items: center;
  justify-content: center;
}
.phoneActive{
  display: block;
  overflow: auto;
}
</style>
<style>
.geetest_wind.geetest_panel .geetest_panel_box.geetest_panelshowslide {
  width: 7.4133rem !important;
  height: 7.6rem !important;
}
</style>
